'use client';

import { useEffect, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { useOtpContext } from '../model';
import { useMobile } from '@shared/hooks';
import { convertToEnglishDigits } from '@shared/lib';

export const useOtpInput = () => {
  const { length, otp, setOtp, inputRef, resend, confirm, open } = useOtpContext();
  const isMobile = useMobile();

  const form = useForm({
    defaultValues: { otp },
  });

  const { watch, setValue, setError, clearErrors, reset } = form;
  const currentOtp = watch('otp');
  const submittedRef = useRef(false);

  useEffect(() => {
    if (currentOtp.length === length && !submittedRef.current) {
      submittedRef.current = true;
      confirm.action(currentOtp);
    }
    if (currentOtp.length < length) submittedRef.current = false;
  }, [currentOtp, length, confirm.action]);

  useEffect(() => {
    if (resend.isSuccess) {
      setValue('otp', '');
      setOtp('');
      submittedRef.current = false;
    }
  }, [resend.isSuccess, setValue, setOtp]);

  useEffect(() => {
    if (!confirm.error) return;
    setError('otp', { type: 'server', message: confirm.error });
    confirm.reset?.();
  }, [confirm.error, confirm.reset, setError]);

  useEffect(() => {
    if (confirm.error && !isMobile) {
      inputRef?.current?.focus();
    }
  }, [confirm.error, isMobile, inputRef]);

  useEffect(() => {
    if (!open) {
      setValue('otp', '');
      setOtp('');
      clearErrors('otp');
      submittedRef.current = false;
    }
  }, [open, setValue, setOtp, clearErrors]);

  const handleChange = (otp: string) => {
    const val = convertToEnglishDigits(otp);
    setValue('otp', val);
    setOtp(val);
    clearErrors('otp');
  };

  return {
    inputRef,
    length,
    isPending: confirm.isPending,
    form,
    handleChange,
  };
};
